/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationModifierRequestSchema } from "./comboCalculationModifierRequestSchema.ts";

export const comboCalculationGroupModifierRequestSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(comboCalculationModifierRequestSchema),
});
